<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="form.file"
                  chips
                  label="Click to pick a file *"
                  @change="readFile"
                ></v-file-input>
                <div v-if="fileLoaded >= 100">File ready to upload</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Upload" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";

const defaultInputs = {
  id: 0,
  accountId: 0,
  name: "string",
  notes: "",
  tags: [],
  folderId: "",
  permissions: [],
};

export default {
  components: {
    AlertMessage,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      id: {},
      name: {},
      accountId: {},
      file: { required },
      notes: {},
      folderId: {},
      tags: {},
    },
  },
  validationMessages: {
    form: {
      id: {},
      clientId: { required: "Required" },
      accountId: {},
      file: {},
      name: { required: "Required" },
      notes: { required: "Required" },
      folderId: { required: "Required" },
      tags: {},
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
      },
      dialog: false,
      valid: false,
      loading: false,
      fileValue: undefined,
      fileLoaded: 0,
      permissions: [],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    folderId(newFolderId) {
      if (!this.isEdit && newFolderId) {
        this.form.folderId = newFolderId;
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        let tags = [];
        if (newTask.categories && newTask.categories.length > 0) {
          tags = newTask.categories.map((i) => i.id);
        }
        this.permissions = newTask.permissions;
        this.form = {
          ...newTask,
          folderId: newTask.id,
          tags,
        };
      } else {
        this.permissions = this.defaultItems;
        this.form = {
          ...defaultInputs,
          folderId: newTask.id,
          permissions: this.defaultItems,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      userGroups: (state) => state.userGroup.data,
      user: (state) => state.account.data.user,
      storage: (state) => state.storage,
      alert: (state) => state.alert,
    }),

    defaultItems() {
      let items = [];
      this.userGroups.forEach((item) => {
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 1,
          access: item.name == "Super Admin" ? true : false,
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 3,
          access: item.name == "Super Admin" ? true : false,
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 4,
          access: item.name == "Super Admin" ? true : false,
        });
      });
      return items;
    },

    getAdminGroup() {
      let found = this.userGroups.filter((item) => item.name == "Super Admin");
      if (found.length === 1) {
        return found[0];
      } else {
        return null;
      }
    },

    formTitle() {
      return this.isEdit ? `Upload new file at "${this.item.name}"` : "Upload New File";
    },
    isEdit() {
      return this.optional(this.item, "id", "") ? true : false;
    },
    taskId() {
      return this.optional(this.item, "id", "");
    },
    folderId() {
      let { folderId } = this.$route.query;
      if (folderId) {
        return parseInt(folderId);
      }
      return "";
    },
    computedPermissions() {
      let permissions = [];
      this.permissions.map((perm) => (permissions = [...permissions, ...perm]));
      return permissions;
    },
  },

  methods: {
    ...mapActions("storage", ["upload", "update"]),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
        };
      }
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.permissions = [];
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.permissions = [];
      this.$emit("onSucceded");
    },

    readFile() {
      this.fileLoaded = 0;
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        const result = event.target.result;
        this.fileValue = result;
        // Do something with result
      });

      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          const percent = (event.loaded / event.total) * 100;
          this.fileLoaded = Math.round(percent);
        }
      });
      if (this.form.file) {
        reader.readAsDataURL(this.form.file);
      }
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      const formData = new FormData();
      formData.append("Files", this.form.file);
      formData.append("FolderId", this.form.folderId);
      formData.append("Notes", this.form.notes);
      await this.upload(formData);

      if (!this.storage.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
      this.permissions = [];
    },
  },
};
</script>